module.exports = __webpack_public_path__ + "img/status-change.02316c32.png";